<template>
  <v-data-table :loading="loading"
                :headers="headers"
                :items="brands"
                item-key="id"
                :items-per-page="-1"
                :footer-props="{'items-per-page-options': [10, 25, 50, 100, -1]}"
                :hide-default-footer="true">
    <template v-slot:item.slug="{item: brand}">
      <router-link :to="{name: 'admin.brand.show', params:{brandID: brand.id}}">
        {{ brand.name }}
      </router-link>
    </template>

    <template v-slot:item.status="{item: brand}">
      <v-btn @click.prevent="changeStatus(brand)"
             :color="brand.is_active ? 'success' : 'warning'"
             x-small>
        {{ brand.status }}
      </v-btn>
    </template>

    <template v-slot:item.actions="{item: brand}">
      <v-btn :to="{name: 'admin.brand.edit', params: {brandID: brand.id}}"
             x-small>
        Edit
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import brandService from '../../../services/brandService';

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    brands: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      busy: false,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Name',
          value: 'slug',
        },
        {
          text: 'External ID',
          value: 'external_id',
        },
        {
          text: 'Presentations',
          value: 'presentations_count',
          cellClass: 'text-right',
        },
        {
          text: 'Email Templates',
          value: 'templates_count',
          cellClass: 'text-right',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ]
    }
  },
  methods: {
    async changeStatus(brand) {
      if (this.busy) {
        return;
      }
      const form = {
        status: brand.is_active ? 'Inactive' : 'Active',
      }
      this.busy = true;
      await brandService.update(brand.id, form)
        .catch(() => {});
      setTimeout(() => {
        this.$emit('updated');
        this.busy = false;
      }, 200);
    }
  }
}
</script>
